import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICreateClientOpts } from 'matrix-js-sdk';
import { SettingsAttributes } from '../settings/settings.service';

export interface SessionData {
  clientOpts: ICreateClientOpts;
  savedSettings: SettingsAttributes;
}

// TODO Wofür sind diese einzelnen Einträge - können die weg?
export const DEVICE_ID = 'deviceID';
export const HOMESERVER_URL = 'homeServerUrl';
export const USER_ID = 'userId';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';

export const SETTINGS = 'settings';

/**
 * Service zur Verwaltung der Matrix-Session und Wiederherstellung einer bestehenden Session.
 * Begründung: Erfüllt keine Anforderung
 */
@Injectable({
  providedIn: 'root'
})
/**
 * Begründung: Keine AFO, weil ...
 */
export class SessionService {
  private readonly _sessionRoomId$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  getSessionRoomId$(): Observable<string> {
    return this._sessionRoomId$.asObservable();
  }

  setSessionRoomId(roomId: string): void {
    this._sessionRoomId$.next(roomId);
  }

  clearSessionData(): void {
    sessionStorage.setItem(DEVICE_ID, '');
    sessionStorage.setItem(HOMESERVER_URL, '');
    sessionStorage.setItem(USER_ID, '');
    sessionStorage.setItem(ACCESS_TOKEN, '');
    sessionStorage.setItem(REFRESH_TOKEN, '');

    sessionStorage.setItem(SETTINGS, '');
  }

  getSessionData(): SessionData | undefined {
    const deviceId = sessionStorage.getItem(DEVICE_ID);
    const baseUrl = sessionStorage.getItem(HOMESERVER_URL);
    const userId = sessionStorage.getItem(USER_ID);
    const accessToken = sessionStorage.getItem(ACCESS_TOKEN);
    const refreshToken = sessionStorage.getItem(REFRESH_TOKEN);

    const settings = sessionStorage.getItem(SETTINGS);

    if (!deviceId || !baseUrl || !userId || !accessToken || !refreshToken || !settings) {
      return undefined;
    }

    const savedSettings = JSON.parse(settings);
    return {
      clientOpts: { deviceId, baseUrl, userId, accessToken, refreshToken },
      savedSettings
    };
  }

  setSessionData({ clientOpts, savedSettings }: SessionData): void {
    sessionStorage.setItem(DEVICE_ID, clientOpts.deviceId ? clientOpts.deviceId : '');
    sessionStorage.setItem(HOMESERVER_URL, clientOpts.baseUrl ? clientOpts.baseUrl : '');
    sessionStorage.setItem(USER_ID, clientOpts.userId ? clientOpts.userId : '');
    sessionStorage.setItem(ACCESS_TOKEN, clientOpts.accessToken ? clientOpts.accessToken : '');
    sessionStorage.setItem(REFRESH_TOKEN, clientOpts.refreshToken ? clientOpts.refreshToken : '');

    sessionStorage.setItem(SETTINGS, savedSettings ? JSON.stringify(savedSettings) : '');
  }
}
